import gsap from "gsap"
import style from './Landing.module.css'
import { useEffect } from "react"
import logo from '../assets/Your paragraph text.png';


export default function Landing()
{
    useEffect(() => {
        gsap.fromTo("#flashingText", {color: 'red',}, {color: "yellow", repeat: -1, yoyo: 'true'})
        gsap.fromTo("#flashingText", {x: -500}, {x: 500, repeat: -1, yoyo: 'true', duration: 10})
    })

    return(
        <div className = {style.Container}>
            <h2>Website rules: No SEX</h2>
            <h2>Additional Rules: ok</h2>

            <img className={style.Img} src = {logo} />

            <h2 className={style.Header} id = "flashingText">BUFF SALAMANDER 🙀</h2>
            <h2 style = {{zIndex: 1000}}>For the healthy life</h2>
            <h2 style = {{zIndex: 1000}}>LOVE </h2>
            <h2 style = {{zIndex: 1000}}>Warning: website is 2 dimensions</h2>
            <h2 style = {{zIndex: 1000}}>If you are not sure, consuult your physician. </h2>
            <h2 style = {{zIndex: 1000}}>5) Find all secret for good fortunes </h2>
            <h2 style = {{zIndex: 1000}}>5) BUFF Salamander<br/> token is COMPLETELY worthless.</h2>
            <p style = {{zIndex: 1000}}>If you are suffering from ailment, <br/>we are not able to assist you from <br/>this due to 
            lack of training. PLase consult a <br/>professional at this time.  This website 
            is <br/>not a medical website and is not intended for treatments. </p>
            <p style = {{zIndex: 1000}}>
                We do not practice any witch craft, alchemy,<br/> or dark magics.  If you are
                practicing such acts, please consult your physician.
            </p>
        </div>
    )
}